/**
 * DUNAMIS WEAR — Product Gallery
 */
(function () {
  'use strict';

  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  const dots = gallery.querySelectorAll('[data-gallery-dot]');
  const slides = gallery.querySelectorAll('[data-gallery-slide]');
  const track = gallery.querySelector('[data-gallery-track]');
  const stacked = gallery.querySelector('.product-gallery__stacked');
  const scrollContainer = track || stacked;
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const lightbox = gallery.querySelector('[data-product-lightbox]');
  const lightboxImage = gallery.querySelector('[data-lightbox-image]');
  const zoomTriggers = gallery.querySelectorAll('[data-gallery-zoom]');

  let current = 0;
  let scrollRaf = 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchMoved = false;
  let suppressClick = false;

  function updateIndicators(index) {
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
  }

  function goTo(index, scrollIntoView) {
    if (!slides.length) return;
    current = Math.max(0, Math.min(index, slides.length - 1));
    updateIndicators(current);

    if (scrollIntoView && scrollContainer && mobileQuery.matches) {
      const target = slides[current];
      if (target) {
        scrollContainer.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      goTo(i, true);
    });
  });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      goTo(i, true);
    });
  });

  function syncFromScroll() {
    if (!scrollContainer || !mobileQuery.matches || !slides.length) return;

    cancelAnimationFrame(scrollRaf);
    scrollRaf = requestAnimationFrame(function () {
      const scrollLeft = scrollContainer.scrollLeft;
      const width = scrollContainer.clientWidth || 1;
      const index = Math.round(scrollLeft / width);
      if (index !== current) {
        current = index;
        updateIndicators(current);
      }
    });
  }

  if (scrollContainer && slides.length > 1) {
    scrollContainer.addEventListener('scroll', syncFromScroll, { passive: true });
  }

  mobileQuery.addEventListener('change', function () {
    if (!mobileQuery.matches) {
      goTo(current, false);
      closeLightbox();
    }
  });

  function getImageFromTrigger(trigger) {
    const img = trigger.querySelector('img');
    return {
      src: trigger.getAttribute('data-full-src') || (img && img.currentSrc) || (img && img.src) || '',
      alt: img ? img.alt : ''
    };
  }

  function openLightbox(trigger) {
    if (!lightbox || !lightboxImage || !trigger) return;

    const image = getImageFromTrigger(trigger);
    if (!image.src) return;

    lightboxImage.src = image.src;
    lightboxImage.alt = image.alt;
    lightbox.removeAttribute('hidden');
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.classList.add('is-open');
    document.body.classList.add('product-lightbox-open');
    document.body.style.overflow = 'hidden';

    if (window.theme && window.theme.mobileViewport) {
      window.theme.mobileViewport.unlock();
    }
  }

  function closeLightbox() {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('hidden', '');
    document.body.classList.remove('product-lightbox-open');
    document.body.style.overflow = '';

    if (window.theme && window.theme.mobileViewport) {
      window.theme.mobileViewport.lock();
    }
  }

  zoomTriggers.forEach(function (trigger) {
    trigger.addEventListener('touchstart', function (event) {
      if (!mobileQuery.matches) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchMoved = false;
    }, { passive: true });

    trigger.addEventListener('touchmove', function (event) {
      if (!mobileQuery.matches) return;
      const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
      if (deltaX > 12 || deltaY > 12) touchMoved = true;
    }, { passive: true });

    trigger.addEventListener('touchend', function () {
      if (!mobileQuery.matches || touchMoved) return;
      suppressClick = true;
      openLightbox(trigger);
    });

    trigger.addEventListener('click', function (event) {
      if (suppressClick) {
        suppressClick = false;
        event.preventDefault();
        return;
      }

      if (mobileQuery.matches) {
        event.preventDefault();
        if (!touchMoved) openLightbox(trigger);
        return;
      }

      openLightbox(trigger);
    });
  });

  gallery.addEventListener('click', function (event) {
    const closeBtn = event.target.closest('[data-lightbox-close]');
    if (closeBtn) {
      event.preventDefault();
      closeLightbox();
    }
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.classList.contains('product-lightbox__stage')) {
        closeLightbox();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
})();
